module.exports = __webpack_public_path__ + "img/phone_w.ebcea875.svg";